import React from "react";
import { withStyles, withTheme, Button } from "@material-ui/core";
import { compose } from "recompose";
import StopKPI from "./StopKPI";
import StopDetails from "./StopDetails";

const styles = (theme) => ({
  container: {
    padding: "5%",
    overflowY: "auto",
    overflowX: "hidden",
    height: "83%",
  },
  smallText: {
    fontSize: "11px",
    lineHeight: "15px",
    color: theme.iconColor,
    padding: "12px 0px",
  },
  headerText: {
    fontWeight: "bold",
    fontSize: 16,
    color: theme.iconColor,
    lineHeight: "21px",
  },
  subHeaderText: {
    fontWeight: "600",
    fontSize: theme.textFontSize,
    lineHeight: "16px",
    color: theme.iconColor,
  },
  topPadding: {
    paddingTop: "24px",
  },
  footer: {
    display: "flex",
    justifyContent: "end",
  },
  buttonStyle: {
    marginLeft: "20px",
    "&$actionDisabled": {
      backgroundColor: theme.customInputBGColor,
      color: `${theme.TextColor} !important`,
      cursor: "not-allowed",
      opacity: 0.8,
    },
  },
  actionDisabled: {
    backgroundColor: theme.customInputBGColor,
    color: `${theme.TextColor} !important`,
    cursor: "not-allowed",
    opacity: 0.8,
  },
});

class DriverDecisionPerStop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      stopDetails: this.props.stopDetails,
      stopIndex: this.props.stopIndex,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.stopDetails != prevProps.stopDetails) {
      this.setState({ stopDetails: this.props.stopDetails });
    }
    if (this.props.stopIndex != prevProps.stopIndex) {
      this.setState({ stopIndex: this.props.stopIndex });
    }
  }

  onNextClick = () => {
    const nextStopId = this.props.stopIndex + 1;
    if (nextStopId < this.props.routeComplianceData.actualStops.length) {
      this.props.onStopClick(nextStopId);
    }
  };

  onPreviousClick = () => {
    const prevStopId = this.props.stopIndex - 1;
    if (prevStopId >= 0) {
      this.props.onStopClick(prevStopId);
    }
  };

  render() {
    const { classes, routeData, routeComplianceData, stopIndex } = this.props;
    const isLastStop = stopIndex === routeComplianceData.actualStops.length - 1;
    return (
      <div className={`${classes.container} customScroll`}>
        <StopKPI
          stopDetails={this.state.stopDetails}
          routeData={routeData}
        ></StopKPI>
        <div className={`${classes.headerText} ${classes.topPadding}`}>
          Stop Deviations
        </div>
        <div className={classes.smallText}>
          Stop Deviation occurs when the driver decides to go to a different
          stop compared to what was proposed (planned stop) to him on his mobile
          app at the time.
        </div>

        <StopDetails stopDetails={this.state.stopDetails}></StopDetails>
        <div className={classes.footer}>
          <Button
            variant="outlined"
            color="primary"
            onClick={this.onPreviousClick}
            disabled={stopIndex === 0}
            classes={{
              disabled: classes.actionDisabled,
            }}
            id="PrevStopButton"
          >
            Prev Stop
          </Button>
          <Button
            variant="contained"
            classes={{
              root: classes.buttonStyle,
              disabled: classes.actionDisabled,
            }}
            onClick={this.onNextClick}
            color="primary"
            disabled={isLastStop}
            id="NextStopButton"
          >
            Next Stop
          </Button>
        </div>
      </div>
    );
  }
}
export default compose(withStyles(styles), withTheme())(DriverDecisionPerStop);
